import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PeymentService } from '@api/peyment.service';

@Component({
  selector: 'app-withdraw-card',
  templateUrl: './withdraw-card.component.html',
  styleUrls: ['./withdraw-card.component.scss']
})
export class WithdrawCardComponent implements OnInit {
  @Input() userInfo: any;
  @Input() amount: string;
  @Input() requestTime: string;
  @Input() bankName: string;
  @Input() ballance: string;
  @Input() id: number;
  body: any;
  withdrawId: number;
  constructor(public router: Router , 
    public paymentService: PeymentService,
    ) { }

  ngOnInit(): void {
    this.withdrawId = this.id;
  }

  withdrawAccept(approveStatus){
   const body = {
    id: +this.withdrawId,
    approveStatus: approveStatus
   }
    this.paymentService.postWithdraw(body).subscribe((res) => console.log(res));
  }

  convertToCommas(x) {
    const value = Math.trunc(x);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

}
